import * as React from 'react';
import {ModuleFE_Dialog, performAction, State_TSDialog, TS_Dialog} from '@nu-art/thunderstorm/frontend';
import {ModuleFE_BaseApi} from '@nu-art/thunderstorm/frontend';
import {DB_Object, Default_UniqueKey, PreDB} from '@nu-art/ts-common';
import {DialogRenderers, Props_BaseDbItemDialog} from './types';


export type State_CreateDialog<T extends DB_Object> = State_TSDialog & { item: PreDB<T> }

export class Dialog_CreateDbItem<T extends DB_Object, Ks extends keyof PreDB<T> = Default_UniqueKey, State extends State_CreateDialog<T> = State_CreateDialog<T>>
	extends TS_Dialog<Props_BaseDbItemDialog<T, Ks, State>, State> {

	static defaultProps = {
		dialogId: 'dialog-update-item'
	};

	static show<T extends DB_Object, Ks extends keyof PreDB<T> = Default_UniqueKey, State extends State_CreateDialog<T> = State_CreateDialog<T>>(item: T, module: ModuleFE_BaseApi<T, Ks>, renderers: DialogRenderers<T, State>) {
		ModuleFE_Dialog.show(<Dialog_CreateDbItem<T, Ks, State> module={module} renderers={renderers}/>);
	}

	protected renderTitle = () => `'Create' ${this.props.renderers.title(this.state.item, this.state)}`;

	// @ts-ignore
	protected renderBody = () => this.props.renderers.body(this.state.item, this.state, this.setState);

	private upsert = () => {
		this.performAction(async () => {
			const title = this.props.renderers.title(this.state.item, this.state);
			await performAction(async () => {
				const item = await this.props.module.v1.upsert(this.state.item).executeSync();
				await this.props?.onCompleted?.(item);
				this.closeDialog();
			}, {
				type: 'toast',
				failContent: `Error creating ${title}`,
				successContent: `${title} was Created`
			});
		});
	};

	buttons = () => ({
		left: [TS_Dialog.Button_Cancel],
		right: [{
			content: 'Create',
			onClick: this.upsert,
			renderer: TS_Dialog.busyButton
		}]
	});

}